import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ScrollToTop from '../components/ScrollToTop';
import BASE_URL from '../BASEURL';

const Gallary = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Gallery - Gujarat State APP Association 2025";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = "Explore our gallery showcasing events, activities, and moments from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    }
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = "https://gsappa.kevalontechnology.in/gallery";
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = 'https://gsappa.kevalontechnology.in/gallery';
      document.head.appendChild(canonical);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = "Gallery - Gujarat State APP Association 2025";
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.content = "Explore our gallery showcasing events, activities, and moments from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.content = "https://gsappa.kevalontechnology.in/gallery";
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) twitterTitle.content = "Gallery - Gujarat State APP Association 2025";
    
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) twitterDescription.content = "Explore our gallery showcasing events, activities, and moments from the Gujarat State Assistant Public Prosecutors Association (GSAPPPA) 2025.";
    
    const twitterUrl = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrl) twitterUrl.content = "https://gsappa.kevalontechnology.in/gallery";

    const fetchGalleries = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/galleries`);
        if (!response.ok) {
          throw new Error('Failed to fetch galleries');
        }
        const data = await response.json();
        setGalleries(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleries();
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  if (loading) {
    return (
      <div className="bg-gradient-to-b from-gray-50 to-white min-h-screen text-gray-800 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-4 border-[#D4A017] mb-4"></div>
          <div className="text-2xl">Loading Photo Gallary...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Error Loading Gallery</h2>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
        <ScrollToTop />
      </>
    );
  }

  return (
    <>
        <section className="relative bg-gradient-to-r from-[#0B0B0B] via-[#1A1A1A] to-[#0B0B0B] text-white py-40 md:py-48 text-center overflow-hidden">
                <div className="absolute inset-0 bg-black/55" />
                <div className="relative z-10 max-w-5xl mx-auto px-6">
                  <motion.h1 initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1.1 }} className="text-5xl md:text-7xl font-extrabold text-[#D4A017] tracking-tight">
Photo Gallary                   </motion.h1>
                  <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5, duration: 1 }} className="mt-6 text-xl md:text-2xl text-gray-200 font-medium">
                    THE GUJARAT STATE ASSISTANT PUBLIC PROSECUTORS ASSOCIATION – 2025
                  </motion.p>
                  <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8, duration: 1 }} className="mt-4 text-lg text-gray-300 max-w-3xl mx-auto">
Explore our collection of memorable moments and events

                  </motion.p>
                </div>
              </section>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="min-h-screen bg-gray-50 py-12"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
         

          {galleries.length === 0 ? (
            <motion.div variants={itemVariants} className="text-center">
              <p className="text-gray-600">No gallery items available at the moment.</p>
            </motion.div>
          ) : (
            <motion.div
              variants={containerVariants}
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
            >
              {galleries.map((gallery) => (
                <motion.div
                  key={gallery._id}
                  variants={itemVariants}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="aspect-w-1 aspect-h-1">
                    <img
                      src={`${gallery.gallary_photo}`}
                      alt={gallery.gallary_name}
                      className="w-full h-48 object-cover"
                      onError={(e) => {
                        e.target.src = '/placeholder-image.jpg'; // Fallback image
                      }}
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{gallery.gallary_name}</h3>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </motion.div>
      <ScrollToTop />
    </>
  );
};

export default Gallary;
